import { TechNavbar } from "@/components/tech/TechNavbar";
import { TechFooter } from "@/components/tech/TechFooter";

const Block = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="text-lg font-extrabold uppercase text-slate-950 mb-3">{title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <div className="font-sans text-slate-900 bg-slate-50 antialiased min-h-screen flex flex-col">
      <TechNavbar />
      <main className="flex-1 py-16">
        <div className="max-w-3xl mx-auto px-6" data-testid="privacy-page">
          <span className="text-xs font-mono uppercase tracking-widest text-blue-600">Documento Legale</span>
          <h1 className="text-3xl md:text-4xl font-extrabold uppercase text-slate-950 mt-1 mb-10">
            Informativa Privacy
          </h1>
          <p className="text-xs font-mono text-slate-500 mb-10">
            Informativa ai sensi dell'art. 13 del Regolamento (UE) 2016/679 ("GDPR")
          </p>

          <Block title="1. Titolare del trattamento">
            <p>
              Il titolare del trattamento dei dati è <strong>SAIRCOS S.R.L.</strong>, con sede legale in Piazza
              Quattro Novembre 4, 20124 Milano (MI), sede operativa in Vicolo San Martino 10, 20016 Pero (MI),
              P.IVA 03216710735, REA MI-2625081.
            </p>
            <p>
              Per qualsiasi richiesta relativa alla privacy:{" "}
              <a href="mailto:info@saircos-spa.it" className="text-blue-600 hover:underline">info@saircos-spa.it</a>{" "}
              · Tel. <a href="tel:+390282396294" className="text-blue-600 hover:underline">02 8239 6294</a>.
            </p>
          </Block>

          <Block title="2. Dati raccolti">
            <p>
              Tramite il modulo di contatto del sito raccogliamo: nome e cognome, indirizzo email, numero di
              telefono (facoltativo), eventuale ente/condominio/committente di riferimento e il contenuto del
              messaggio inviato.
            </p>
            <p>
              Il sito non utilizza cookie di profilazione né strumenti di tracciamento di terze parti.
            </p>
          </Block>

          <Block title="3. Finalità e base giuridica">
            <p>
              I dati sono trattati esclusivamente per rispondere alla richiesta di preventivo, sopralluogo o
              contatto inviata tramite il sito (esecuzione di misure precontrattuali su richiesta
              dell'interessato, art. 6.1.b GDPR) e per gli adempimenti amministrativi e fiscali connessi.
            </p>
          </Block>

          <Block title="4. Conservazione e comunicazione">
            <p>
              I dati sono conservati per il tempo necessario a gestire la richiesta e, in caso di incarico, per
              i termini previsti dagli obblighi di legge. Non sono ceduti a terzi né diffusi; possono essere
              trattati da fornitori tecnici (hosting e servizio email) nominati responsabili del trattamento.
            </p>
          </Block>

          <Block title="5. Diritti dell'interessato">
            <p>
              Puoi esercitare in qualsiasi momento i diritti di accesso, rettifica, cancellazione, limitazione,
              opposizione e portabilità dei dati (artt. 15–22 GDPR) scrivendo a{" "}
              <a href="mailto:info@saircos-spa.it" className="text-blue-600 hover:underline">info@saircos-spa.it</a>.
              Hai inoltre diritto di reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).
            </p>
          </Block>

          <a href="/" className="inline-block mt-4 text-xs font-bold font-mono uppercase text-blue-600 hover:text-blue-800 transition-colors">
            ← Torna alla home
          </a>
        </div>
      </main>
      <TechFooter />
    </div>
  );
}
